// extracted by mini-css-extract-plugin
export default {"CloseButton":"CloseButton_CloseButton__tsDoQ"};